// Protected route component to guard authenticated routes
import React from 'react';
import { Navigate, useLocation } from 'react-router-dom';
import { useAuth } from '../../contexts/AuthContext';

function ProtectedRoute({ children, requireAuth = true }) {
  const { isAuthenticated, isLoading } = useAuth();
  const location = useLocation();

  // Show loading while checking authentication
  if (isLoading) {
    return (
      <div className="auth-loading">
        <div className="auth-loading-spinner"></div>
        <p>Checking authentication...</p>
      </div>
    );
  }

  // If route requires auth but user is not authenticated
  if (requireAuth && !isAuthenticated) {
    // Redirect to login with return path
    return (
      <Navigate 
        to="/login" 
        state={{ from: location }} 
        replace 
      />
    );
  }

  // If route is for non-authenticated users (like login/register) but user is authenticated
  if (!requireAuth && isAuthenticated) {
    // Redirect to the intended page or diary
    const from = location.state?.from?.pathname || '/diary';
    return <Navigate to={from} replace />;
  }

  return children;
}

export default ProtectedRoute;
